const checkSetup = (): boolean => {
  const scriptExists = typeof window['Appcues'] !== 'undefined';

  if (!scriptExists) {
    console.warn('Appcues script not found');
  }

  return scriptExists;
};

export default checkSetup;
